/* eslint-disable react/prop-types */ // TODO: add props
import { Button } from 'edrolo-style-guide';
import { FormGroup, FormControl } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import GrokSelfReflection from '../../../GrokSelfReflection';
import QuestionSolution from '../../../QuestionSolution';
import s from './styles.scss';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import Immutable from 'immutable';

export const FillInBlankQuestion = ({
  question,
  response,
  onSubmit,
  onSubmitGrok,
  grokkingItemIsSaving,
  onSubmitTeacherAnswer,
  isQuestionReview,
  isPrint,
}) => {
  const [answers, setAnswers] = useState([]);
  const imageUrl = question.get('image_url');
  const fields = question.get('fields').toJS();

  useEffect(() => {
    const fieldResponses = response?.get('field_responses') || Immutable.List();
    if (!fieldResponses.size) {
      return;
    }

    setAnswers(
      fieldResponses
        .map((fieldResponse) => ({
          fieldId: fieldResponse.get('field_id'),
          submittedValue: fieldResponse.get('submitted_value'),
        }))
        .toArray()
    );
  }, [response]);

  function updateAnswers(value, id) {
    let newAnswers = answers ? [...answers] : [];

    const existingAnswer = newAnswers.find((a) => a?.fieldId === id);

    if (!existingAnswer) {
      newAnswers.push({ fieldId: id, submittedValue: value });
    }

    if (existingAnswer && !value.length) {
      newAnswers = newAnswers.filter((a) => a.fieldId !== id);
    }

    if (existingAnswer && !!value.length) {
      newAnswers = newAnswers.filter((a) => a.fieldId !== id);
      newAnswers.push({
        fieldId: id,
        submittedValue: value,
      });
    }

    setAnswers(newAnswers);
  }

  return (
    <>
      <form className={s.fillInBlank}>
        <div className={s.imageWrapper}>
          <FormGroup className={s.formGroup}>
            {fields?.map((field) => {
              const {
                id: fieldId,
                width,
                height,
                x_position,
                y_position,
              } = field;
              const submittedValue =
                answers?.find((a) => a.fieldId === fieldId)?.submittedValue ||
                '';

              return (
                <FormControl
                  key={fieldId}
                  componentClass="textarea"
                  onChange={(e) => updateAnswers(e.target.value, fieldId)}
                  value={submittedValue}
                  style={{
                    left: `${x_position}%`,
                    top: `${y_position}%`,
                    height: `${height}%`,
                    width: `${width}%`,
                  }}
                  disabled={!!response}
                />
              );
            })}
          </FormGroup>
          <img src={imageUrl} />
        </div>
      </form>

      {!response && !isQuestionReview && (
        <div>
          <Button
            onClick={() =>
              onSubmitTeacherAnswer
                ? onSubmitTeacherAnswer()
                : onSubmit({ fieldResponses: answers })
            }
            disabled={!answers.length}
          >
            {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
          </Button>
        </div>
      )}

      {!!response && !isQuestionReview && (
        <>
          <QuestionSolution
            headingText="Solution"
            questionId={question.get('id')}
            explanation={response.getIn(['solution', 'explanation'])}
            videoHash={response.getIn([
              'solution',
              'video',
              'wistia_hashed_id',
            ])}
            videoThumbnailUrl={WistiaUtils.getThumbnail(
              response.getIn(['solution', 'video'])
            )}
          />
          {!isPrint && (
            <GrokSelfReflection
              value={response.get('grokked')}
              onChange={onSubmitGrok}
              isSaving={grokkingItemIsSaving}
              className={s.selfReflection}
            />
          )}
        </>
      )}
    </>
  );
};

FillInBlankQuestion.defaultProps = {
  isQuestionReview: false,
};
